import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../logo.png';
import fleur from '../fleur.png';
import { FaFacebookF, FaInstagram, FaYoutube, FaTelegram } from 'react-icons/fa';
import { useResponsive } from '../hooks/useResponsive';

// Liens internes : libellé + route réelle (voir App.js)
const LIENS_UTILES = [
    { label: 'À propos', to: '/about' },
    { label: 'Comment ça marche', to: '/comment' },
    { label: 'Fonctionnalités', to: '/fonctionnalites' },
    { label: 'Contact', to: '/contact' },
];

// Aide & support : seule "Nous contacter" a une page existante pour l'instant.
// Les autres pointeront vers leurs pages une fois créées (FAQ, CGU, confidentialité).
const AIDE_SUPPORT = [
    { label: 'Questions fréquentes', to: '/contact' },
    { label: "Conditions d'utilisation", to: '/mentions-legales' },
    { label: 'Politique de confidentialité', to: '/mentions-legales' },

];

// Réseaux sociaux : renseigner les vraies URL. Laisser null pour désactiver.
const SOCIALS = [
    { Icon: FaFacebookF, url: null },
    { Icon: FaInstagram, url: null },
    { Icon: FaYoutube, url: null },
    { Icon: FaTelegram, url: null },
];

const Footer = () => {
    const { isSmall, isMobile, isTablet } = useResponsive();

    return (
        <footer style={{ backgroundColor: '#4a0028' }}>
            <div style={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                alignItems: isMobile ? 'center' : 'flex-start',
                justifyContent: isMobile ? 'center' : 'space-between',
                padding: isMobile ? '32px 20px' : isTablet ? '24px 24px' : '24px 48px 24px 0px',
                gap: isMobile ? '32px' : '0px',
                flexWrap: isTablet && !isMobile ? 'wrap' : 'nowrap',
                fontFamily: 'Arial, sans-serif',
            }}>
                {!isMobile && (
                    <img src={fleur} alt="" style={{ height: isTablet ? '120px' : '160px', width: 'auto', flexShrink: 0 }} />
                )}
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                    <img src={logo} alt="Zawaj Tawadud" style={{
                        height: isMobile ? '70px' : isTablet ? '75px' : '80px', width: 'auto', display: 'block',
                        objectFit: 'contain',
                        marginBottom: '12px', marginTop: '0',
                    }} />
                    <p style={{ color: 'white', fontSize: isSmall ? '11px' : '13px', lineHeight: '1.8', margin: 0, maxWidth: '200px', textAlign: 'center' }}>
                        Une plateforme de mise en relation sérieuse et éthique, conforme à l&rsquo;Islam et aux valeurs musulmanes.
                    </p>
                </div>
                <div style={{ textAlign: isMobile ? 'center' : 'left' }}>
                    <h4 style={styles.colTitle}>Liens utiles</h4>
                    {LIENS_UTILES.map((l, i) => (
                        <Link key={i} to={l.to} style={styles.colLink}>{l.label}</Link>
                    ))}
                </div>
                <div style={{ textAlign: isMobile ? 'center' : 'left', marginRight: isMobile ? '0' : isTablet ? '0' : '40px' }}>
                    <h4 style={styles.colTitle}>Aide & support</h4>
                    {AIDE_SUPPORT.map((l, i) => (
                        l.to
                            ? <Link key={i} to={l.to} style={styles.colLink}>{l.label}</Link>
                            : <span key={i} style={{ ...styles.colLink, cursor: 'default', opacity: 0.6 }}>{l.label}</span>
                    ))}
                </div>
                <div style={{ textAlign: isMobile ? 'center' : 'left' }}>
                    <h4 style={styles.colTitle}>Suivez-nous</h4>
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', justifyContent: isMobile ? 'center' : 'flex-start' }}>
                        {SOCIALS.map(({ Icon, url }, i) => (
                            url
                                ? <a key={i} href={url} target="_blank" rel="noopener noreferrer" style={styles.socialIcon}><Icon size={14} /></a>
                                : <span key={i} style={{ ...styles.socialIcon, cursor: 'default', opacity: 0.5 }}><Icon size={14} /></span>
                        ))}
                    </div>
                </div>
            </div>
            <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', padding: '18px 20px', textAlign: 'center', backgroundColor: '#4a0028' }}>
                <p style={{ color: 'rgba(255,255,255,0.25)', fontSize: '13px', margin: 0 }}>
                    © 2026 Zawaj & Tawadud — Tous droits réservés.
                </p>
            </div>
        </footer>
    );
};

const styles = {
    colTitle: { color: 'white', fontSize: '14px', fontWeight: '700', marginBottom: '16px', marginTop: 0 },
    colLink: { display: 'block', color: 'white', fontSize: '13px', textDecoration: 'none', marginBottom: '10px', whiteSpace: 'nowrap' },
    socialIcon: { width: '38px', height: '38px', borderRadius: '50%', border: '1.5px solid rgba(255,255,255,0.3)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(255,255,255,0.8)', textDecoration: 'none' },
};

export default Footer;